import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
export var Container = styled.div.withConfig({
  displayName: "Hintstyles__Container",
  componentId: "keen-query-creator__sc-sdikd4-0"
})(["&&&{position:relative;}"]);
export var TooltipContainer = styled(motion.div).withConfig({
  displayName: "Hintstyles__TooltipContainer",
  componentId: "keen-query-creator__sc-sdikd4-1"
})(["&&&{position:absolute;pointer-events:none;z-index:1;width:258px;font-family:'Lato Regular',sans-serif;font-size:14px;", ";", ";", ";", ";}"], function (props) {
  return props.position === 'top' && css(["left:", "px;top:", "px;"], function (props) {
    return -props.tooltipWidth / 2 + props.width / 2;
  }, function (props) {
    return -props.tooltipHeight - props.height / 2;
  });
}, function (props) {
  return props.position === 'bottom' && css(["left:", "px;top:", "px;"], function (props) {
    return -props.tooltipWidth / 2 + props.width / 2;
  }, function (props) {
    return props.height * 1.5;
  });
}, function (props) {
  return props.position === 'left' && css(["left:", "px;top:", "px;"], function (props) {
    return -props.tooltipWidth - props.width / 2;
  }, function (props) {
    return -props.tooltipHeight / 2 + props.height / 2;
  });
}, function (props) {
  return props.position === 'right' && css(["left:", "px;top:", "px;"], function (props) {
    return props.width * 1.5;
  }, function (props) {
    return -props.tooltipHeight / 2 + props.height / 2;
  });
});